module.exports = __webpack_public_path__ + "img/img19.49227f8d.svg";